import { ReactNode } from "react";
import { Box } from "@mui/material";
import { DotLegalHeader, DotLegalPaper } from "@dotlegal/dotlegal-ui-components";

// Fixed content height keeps side-by-side panels the same height regardless of their inner chart chrome (e.g. a legend row).
export const chartContentHeight = 300;

// The lavender wrapper shared by the report's KPI card row and chart panels.
export const reportPanelBackground = "#EEEFFA";

interface RiskReportChartPanelProps {
    header: string;
    children: ReactNode;
}

function RiskReportChartPanel({ header, children }: RiskReportChartPanelProps) {
    return (
        <Box sx={{ height: "100%", padding: 2, backgroundColor: reportPanelBackground, borderRadius: "20px" }}>
            <DotLegalHeader color="primary" headerStyle="medium" marginBottom={2}>
                {header.toUpperCase()}
            </DotLegalHeader>
            <DotLegalPaper>
                <Box sx={{ height: chartContentHeight }}>{children}</Box>
            </DotLegalPaper>
        </Box>
    );
}

export default RiskReportChartPanel;
